import {
  faAddressCard,
  faCalendarDay,
  faCalendarTimes,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SideStepper } from '@vadiun/react-components';
import { BillerModel } from 'app/biller/models/BillerModel';
import { BusinessUnitType } from 'app/business/services/useBusinessUnit';
import  { useEffect, useState } from 'react';
import { VehiculoPartialModel } from '../../vehiculos/models/Vehiculo';
import {
  ChoferCreateFormSchema,
  choferFormSchemaInitialValues,
} from '../models/ChoferFormSchema';
import ChoferFormGeneral from './ChoferForm/ChoferFormGeneral';
import ChoferFormPersonal from './ChoferForm/ChoferFormPersonal';
import ChoferFormVencimientos from './ChoferForm/ChoferFormVencimientos';
import ChoferTurnCreate from './ChoferTurnCreate';
import { VisiblePages } from '../models/choferPages';
import { ChoferModelSinTurno } from '../models/Chofer';

interface Props {
  vehiculos: VehiculoPartialModel[];
  create: (choferFormSchema: ChoferCreateFormSchema, reset) => void;
  proveedores: BillerModel[];
  businessUnit: BusinessUnitType[];
  createdChofer: ChoferModelSinTurno ;
  setVisiblePage: (visiblePage: VisiblePages) => void;
}

const ChoferCreate = ({
  vehiculos,
  create,
  proveedores,
  businessUnit,
  createdChofer,
  setVisiblePage
}: Props) => {
  const [currentStep, setCurrentStep] = useState<
  'general' | 'personal' | 'turno' | 'vencimientos'
  >('general');
  const [choferForm, setChoferForm] = useState(
    choferFormSchemaInitialValues(vehiculos, proveedores)
  );
  const [showTurnCreate, setShowTurnCreate] = useState(false);

  

  useEffect(() => { 
    if (createdChofer.id) {
      setCurrentStep('turno');
      setShowTurnCreate(true);
      setVisiblePage(VisiblePages.TURNO);
    }
  }, [createdChofer.id]);

  
  const steps = {
    general: (
      <ChoferFormGeneral
        submitButtonTitle="Continuar"
        vehiculos={vehiculos}
        proveedores={proveedores}
        businessUnit={businessUnit}
        onSubmit={(values) => {
          setChoferForm((currentValue) => ({
            ...currentValue,
            general: values
          }));
          setCurrentStep('personal');
        }}
        initialValues={choferForm.general}
      />
    ),
    personal: (
      <ChoferFormPersonal
        onSubmit={(values) => {
          setChoferForm((currentValue) => ({
            ...currentValue,
            personal: values
          }));
          setCurrentStep('vencimientos');
        }}
        submitButtonTitle="Continuar"
        onGoBack={() => setCurrentStep('general')}
        initialValues={choferForm.personal}
      />
    ),
     vencimientos: (
      <ChoferFormVencimientos
        onSubmit={async(values) => {
          try {
            const createdChofer = await create({ ...choferForm, vencimientos: values }, () =>
              setChoferForm(choferFormSchemaInitialValues(vehiculos, proveedores))
            );
          } catch (error) {
             console.error('Error creating chofer:', error);
          }
        }}
        initialValues={choferForm.vencimientos}
        onGoBack={() => setCurrentStep('personal')}
        isDriverEnabledToBusesService={
          choferForm.general.businessUnit?.name === 'Buses' ? true : false
        }
      />
    ),
    turno: (
     showTurnCreate  &&<ChoferTurnCreate  createdChofer={createdChofer}  setCurrentStep={setCurrentStep} setVisiblePage={setVisiblePage} />
    ),
   
  };
  return (
    <div className="w-full flex flex-col md:flex-row bg-white">
      <div className="p-8">
        <SideStepper.Container value={currentStep}>
          <SideStepper.Step
            icon={<FontAwesomeIcon icon={faUser} />}
            value={'general'}
            label="Informacion general"
          />
          <SideStepper.Step
            icon={<FontAwesomeIcon icon={faAddressCard} />}
            value={'personal'}
            label="Informacion personal"
          />
          <SideStepper.Step
            icon={<FontAwesomeIcon icon={faCalendarTimes} />}
            value={'vencimientos'}
            label="Vencimientos"
          />
          <SideStepper.Step
            icon={<FontAwesomeIcon icon={faCalendarDay} />}
            value={'turno'}
            label="Turno"
          />
        </SideStepper.Container>
      </div>
      <div className="border-l-2 border-gray-200 border-solid p-12 w-full">
        {steps[currentStep]}
      </div>
    </div>
  );
};

export default ChoferCreate;